/**
 * @author        calvin@zumper.com (Calvin Yau)
 * @copyright     Copyright (c) 2022, Zumper
 */

import { filterActions } from '@zumper/redux-ignore'

import * as constants from './constants'
import { faqDataReducer } from './reducers/index'

export const faqDataRootReducer = filterActions(faqDataReducer, Object.values(constants))
